<template>
  <content-layout
    v-if="projects"
    headingId="headingId"
    paraId="proj-name"
    :para1="projectDetails.heading"
    :para2="projectDetails.overview"
    :isIndex="false"
    :projViewed="viewId"
    :projects="projects"
    @nextProject="display"
  >
    <template #heading>
      Projects / <i @click="showGroup">{{ projGroup }}</i>
      <div @click="showGroup" class="img-container">
        <img src="@/assets/arrow-icon-dark.png" alt="" />
      </div>
      <i @click="switchGroup" v-if="isVisible" id="switch">{{ altGroup[0] }}</i>
    </template>
    <template #links>
      <div id="project-links">
        <a
          v-if="projectDetails.viewProj"
          :href="projectDetails.viewProj"
          :target="linkTarget.viewProj"
          >View Project</a
        >
        <a
          v-if="projectDetails.codeLink"
          :href="projectDetails.codeLink"
          :target="linkTarget.codeLink"
          >View Source Code</a
        >
        <a
          v-if="projectDetails.demonstration"
          :href="projectDetails.demonstration"
          :target="linkTarget.demonstration"
          >View Demonstration</a
        >
      </div>
    </template>
  </content-layout>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import ContentLayout from "../components/layout/ContentLayout.vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
const store = useStore();
const route = useRoute();

const projGroup = ref("");
const projectDetails = ref("");
const projects = ref("");

const viewId = ref("");
const isVisible = ref(false);

const whichQuery = computed(() => {
  if (
    route.query.group &&
    route.query.group === "mini" &&
    route.query.index &&
    store.getters["writeups/isValid"](["mini", route.query.index])
  )
    return ["mini", route.query.index.toLowerCase()];
  if (route.query.group && route.query.group === "mini" && !route.query.index)
    return ["mini", "grid"];
  else if (
    route.query.group &&
    route.query.group === "mega" &&
    route.query.index &&
    store.getters["writeups/isValid"](["mega", route.query.index.toLowerCase()])
  )
    return ["mega", route.query.index.toLowerCase()];
  else return ["mega", "portfolio"];
});

const display = (projectKey) => {
  projectDetails.value = store.getters[`writeups/project`]([
    projGroup.value,
    projectKey,
  ]);
  projects.value = store.getters[`writeups/projects`](
    projGroup.value.toLowerCase()
  );
  viewId.value = projectKey;
};

const altGroup = computed(() => {
  if (projGroup.value.toLowerCase() === "mini") return ["mega", "portfolio"];
  else return ["mini", "grid"];
});

//  Display a dropdown menu
const showGroup = () => {
  const el = document.querySelector("#headingId img");
  if (isVisible.value) {
    el.style.transform = "rotate(0deg)";
    const temp = document.querySelector("#switch");
    temp.classList.remove("make-visible");
    setTimeout(() => {
      isVisible.value = false;
    }, 300); //  let animation finish
  } else {
    isVisible.value = true;
    setTimeout(() => {
      const temp = document.querySelector("#switch");
      temp.classList.add("make-visible");
      el.style.transform = "rotate(90deg)";
    }, 20); //  Ensure that the component is mounted
  }
};
const switchGroup = () => {
  const el = document.querySelector("#headingId img");
  el.style.transform = "rotate(0deg)";
  const temp = altGroup.value[1];
  projGroup.value = altGroup.value[0];
  display(temp);
  const el2 = document.querySelector("#switch");
  el2.classList.remove("make-visible");
  setTimeout(() => {
    isVisible.value = false;
  }, 300); //  let animation finish
};

const linkTarget = computed(() => ({
  viewProj: projectDetails.value.viewProj?.includes("https")
    ? "_blank"
    : "_self",
  codeLink: projectDetails.value.codeLink?.includes("https")
    ? "_blank"
    : "_self",
  demonstration: projectDetails.value.demonstration?.includes("https")
    ? "_blank"
    : "_self",
}));

onMounted(() => {
  document.title = "Reggenius | Projects";
  projGroup.value = whichQuery.value[0];
  display(whichQuery.value[1]);
});
</script>
